import { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import { DndContext, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { arrayMoveImmutable } from 'array-move';
import * as _ from 'lodash';
import { isEmpty } from 'lodash';
import { Alert, Button, Checkbox, Col, Dropdown, Empty, Form, Input, Layout, message, Modal, Popconfirm, Radio, Row, Space, Spin, Switch, Tabs, Tag, Tooltip, Tree, TreeSelect, Typography } from 'antd';
import { localStorageGet } from '@core/cookie';
import './AgendaList.less';
import AddConferenceDrawer from './components/AddConferenceDrawer';
import AddAgendaDrawer from './components/AddAgendaDrawer';
import OperationLogDrawer from '@/components/common/OperationLogDrawer';
import { logAgendaReorder } from '@/utils/conferenceLogger';
import ChangeConferenceDateModal from './components/ChangeConferenceDateModal';
import SeatingArrangementModal from './components/SeatingArrangementModal';
import { changeAgendaAndGuestsStatusApi, changeConferenceHallStatusApi, deleteAgendaApi, deleteConferenceApi, getAgendasListApi, getConferenceListApi, getConferencePlacesOverview, getOrganisationinfoApi, pdfExportDownloadApi, sortAgendaApi, sortConferenceApi, getSortTotalApi } from '@services/Agenda';
import { conferenceOnceApi, deleteConferenceCache } from '@services/Conference';
import { getAllEnterpriseApi, getBossStaffs } from '@services/Enterprise';
import PreviewAgendasDrawer from './components/PreviewAgendasDrawer';
import { get } from '@/core/request';
import config from '@config';
import dayjs from 'dayjs';
import { convertDateTimeRangeToLocalText, dateTimeFormat } from '@utils/utils';
import { filterTreeNodeByTitle } from '@/utils/antdTreeSelect';
import html2canvas from 'html2canvas';
import styled from 'styled-components';
import PopoverTip from '../../common/PopoverTip';
import { AgendaSortableRow, SortableMainHallRow } from './AgendaListSortableRows';
import PageHeader from '@components/PageHeader/PageHeader';
import { CONFERENCE_WORKSPACE_PARENT_PATH, CONFERENCE_WORKSPACE_ROUTE_BASE } from '@/layouts/conferenceWorkspaceConfig';
const StyledAgendaExportSetup = styled.div`
    position: relative;
    min-height: 200px;

    .agenda-template-setting-btn {
        position: absolute;
        top: 0;
        right: 0;
    }

    .conf-hall-tree {
        padding: 10px 8px;
        border: 1px solid var(--ant-color-border-secondary);
        margin: 8px 0 20px;
        border-radius: var(--ant-border-radius);

        .ant-tree-list-holder-inner {
            max-height: 500px;
            overflow-y: auto;

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-track {
                background: var(--ant-color-fill-quaternary);
                border-radius: 5px;
            }

            &::-webkit-scrollbar-thumb {
                background: var(--ant-color-fill-secondary);
                border-radius: 5px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: var(--ant-color-fill);
            }

        }
    }

    .visible-conf-hall-only {
        margin-top: 4px;
    }

    .confirm-only {
        display: flex;
        align-items: center;
        margin-top: 16px;
    }

    .extra {
        span {
            color: var(--ant-color-text-tertiary);
        }
    }
`;

export default function AgendaList() {
    const params = useParams();
    let conferenceId = params?.id || 0; // 会议项目 ID
    conferenceId = parseInt(conferenceId, 10) || 0;
    // console.log('conferenceId', conferenceId);

    const [conference, setConference] = useState(null);
    const [laborFeeConfirmed, setLaborFeeConfirmed] = useState(false);

    // 新增/编辑会议（场次）Drawer
    const [currentConferenceHall, setCurrentConferenceHall] = useState(null); // 当前会议
    const [visibleAddConferenceHallDrawer, setVisibleAddConferenceHallDrawer] = useState(false);
    const [conferenceDetail, setConferenceDetail] = useState(null);
    const [conferenceData, setConferenceData] = useState({});
    const [dateList, setDateList] = useState([]);
    const currentDate = useRef(null);
    const [conferenceHallTreeData, setConferenceHallTreeData] = useState([]);
    const [tabActiveKey, setTabActiveKey] = useState('');

    const [staffs, setStaffs] = useState([]);
    const [enterprisePerson, setEnterprisePerson] = useState([]);
    const [sponsorHosName, setSponsorHosName] = useState('');

    // 会议地点一览
    const [placesOverviewData, setPlacesOverviewData] = useState(null);
    const [visiblePlacesOverviewModal, setVisiblePlacesOverviewModal] = useState(false);
    const [loadingPlacesOverview, setLoadingPlacesOverview] = useState(false);
    const [specInstructionEnabled, setSpecInstructionEnabled] = useState(true);

    const [wordExportLoading, setWordExportLoading] = useState(false);

    const [visibleExportPrintAgendaModal, setVisibleExportPrintAgendaModal] = useState(false);
    const [showWordTemplateSettings, setShowWordTemplateSettings] = useState(false);
    const [confirmOnly, setConfirmOnly] = useState(true); // 仅导出已确认日程任务的嘉宾
    const [plannedAgendas, setPlannedAgendas] = useState(false); // 以拟定日程表头导出日程
    const [includeHidden, setIncludeHidden] = useState(false); // 隐藏会议场次、日程、日程嘉宾一并导出
    const [checkedConfHallKeys, setCheckedConfHallKeys] = useState([]);
    const [selectedConfHallKeys, setSelectedConfHallKeys] = useState([]);

    // Word模板设置相关状态
    const [wordTemplateForm] = Form.useForm();

    // 颜色列表
    const colorList = ['#f5222d', '#fa541c', '#fa8c16', '#52c41a', '#1677ff', '#0327ff', '#722ed1', '#eb2f96', '#333333', '#888888', '#ffffff'].map(c => c.toUpperCase());

    const [visibleExportPrintHost, setVisibleExportPrintHost] = useState(false);
    const [currentHostConfHallKey, setCurrentHostConfHallKey] = useState(null);
    const currentHostConfHallRef = useRef(null);

    // 全屏状态
    const [isFullscreen, setIsFullscreen] = useState(false);

    // 桌签排序Modal状态
    const [visibleSeatingArrangementModal, setVisibleSeatingArrangementModal] = useState(false);
    const [sortInfo, setSortInfo] = useState({ expertsCount: 0, sortStatus: 0 }); // 排序信息

    const dndSensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: { distance: 10 },
        }),
    );

    // 处理当前会议变化时载入排序信息
    const getSortTotal = checkId => {
        getSortTotalApi({ hallId: checkId })
            .then(res => {
                if (res?.data) {
                    setSortInfo({
                        expertsCount: res.data.expertsCount || 0,
                        sortStatus: res.data.sortStatus || 0,
                    });
                }
            })
            .catch(err => console.error('获取排序信息失败:', err));
    };

    // 打开桌签排序Modal
    const openSeatingArrangementModal = () => {
        setVisibleSeatingArrangementModal(true);
    };

    // 关闭桌签排序Modal
    // ... existing code ...
    const closeSeatingArrangementModal = () => {
        setVisibleSeatingArrangementModal(false);
        // 刷新排序信息
        if (currentConferenceHall?.id) {
            getSortTotal(currentConferenceHall?.id);
        }
    };

    // 导出打印版日程对话框中勾选会议场次
    const onCheckConfHallForAgendaExport = (checkedKeys, info) => {
        console.log('onCheckConfHallForAgendaExport', checkedKeys, info);

        // 当使用受控模式（即设置了 checkedKeys 属性）时，需要同时处理 onCheck 事件来更新 checkedKeys 的值。
        setCheckedConfHallKeys(checkedKeys);

        setSelectedConfHallKeys(checkedKeys.filter(k => typeof k === 'number'));
    };

    // 全屏切换
    const handleToggleFullscreen = useCallback(() => {
        const target = document.querySelector('main.main-container');
        if (!target) return;
        const next = !target.classList.contains('is-page-fullscreen');
        target.classList.toggle('is-page-fullscreen', next);
        setIsFullscreen(next);
    }, []);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.key !== 'Escape') return;
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (!target) return;
            target.classList.remove('is-page-fullscreen');
            setIsFullscreen(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    useEffect(() => {
        return () => {
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (target) target.classList.remove('is-page-fullscreen');
        };
    }, []);

    // 仅导出已确认日程
    const onChangeConfirmOnly = e => {
        // console.log(e.target.checked);
        setConfirmOnly(e.target.checked);
    };

    // 以拟定日程表头导出日程
    const onChangePlannedAgendas = e => {
        setPlannedAgendas(e.target.checked);
    };

    const onChangeIncludeHidden = e => {
        setIncludeHidden(e.target.checked);
    };

    const openExportPrintAgendaModal = () => {
        setVisibleExportPrintAgendaModal(true);
    };

    // 关闭导出打印版日程对话框
    const closeExportPrintAgendaModal = () => {
        setVisibleExportPrintAgendaModal(false);
        wordTemplateForm.resetFields();
        setShowWordTemplateSettings(false);
    };

    // 切换Word模板设置显示状态
    const toggleWordTemplateSettings = () => {
        setShowWordTemplateSettings(!showWordTemplateSettings);
    };

    // 仅保存Word模板设置
    const saveWordTemplateOnly = async () => {
        try {
            const values = await wordTemplateForm.validateFields();
            const saved = await saveWordTemplateSettings(values);
            if (saved) {
                message.success('Word模板设置保存成功');
            }
        } catch (error) {
            console.error('保存Word模板设置失败:', error);
            message.error('保存Word模板设置失败');
        }
    };

    // Word模板设置相关函数
    // 背景色设置
    const changeBgColor = (item, fieldName) => {
        wordTemplateForm.setFieldValue([...fieldName], item);
    };

    // 获取上传文件URL
    const getFileUrl = url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return config.OSS_PREFIX + url;
        }
        return null;
    };

    // 保存Word模板设置
    const saveWordTemplateSettings = async values => {
        try {
            const currentSettings = conference?.agendaSettings ? JSON.parse(conference.agendaSettings) : {};
            const newSettings = {
                ...currentSettings,
                print: values.print,
            };

            const { updateAgendaSettings } = await import('@services/Agenda');
            const res = await updateAgendaSettings({
                id: conferenceId,
                agendaSettings: JSON.stringify(newSettings),
            });

            if (res.status_code === 200) {
                await getConferenceInfo(conferenceId);
                return true;
            }
            return false;
        } catch (error) {
            console.error('保存Word模板设置失败:', error);
            return false;
        }
    };

    // 导出打印版日程
    const exportPrintAgenda = async () => {
        setWordExportLoading(true);

        try {
            // 如果显示了模板设置，先保存Word模板设置
            if (showWordTemplateSettings) {
                try {
                    const values = await wordTemplateForm.validateFields();
                    const saved = await saveWordTemplateSettings(values);
                    if (!saved) {
                        message.error('保存Word版日程模板设置失败');
                        setWordExportLoading(false);
                        return;
                    }
                    message.success('Word版日程模板设置保存成功');
                } catch (error) {
                    console.error('保存Word版日程模板设置失败:', error);
                    message.error('保存Word版日程模板设置失败');
                    setWordExportLoading(false);
                    return;
                }
            }

            // 检查是否选择了会议场次
            let params = { conferenceId };
            if (selectedConfHallKeys.length) {
                params = { ...params, conferenceHallIds: selectedConfHallKeys.join(',') };
            } else {
                message.warning('请选择要导出的会议场次');
                setWordExportLoading(false);
                return;
            }
            if (confirmOnly) {
                params = { ...params, confirmedOnly: 1 };
            }
            if (plannedAgendas) {
                params = { ...params, plan: 1 };
            }
            if (includeHidden) {
                params = { ...params, includeHidden: 1 };
            }

            // 调用导出函数，该函数内部会处理 loading 状态
            exportAgendasWord(params);
        } catch (error) {
            console.error('导出Word版日程失败:', error);
            message.error('导出Word版日程失败');
            setWordExportLoading(false);
        }
    };

    const exportAgendasWord = params => {
        setWordExportLoading(true);

        // let params = { conferenceId };
        const url = '/conference/boss/agendas/word-export/agenda-download';
        get(url, params, { responseType: 'blob' })
            .then(res => {
                message.success('请稍后，正在导出');

                const blob = new Blob([res], { type: 'application/octet-stream' });
                if ('download' in document.createElement('a')) {
                    const fileNameSuffix = '_' + dayjs().format('YYYYMMDD_HHmmss') + '.docx';

                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.download = 'Word版日程_' + conference.name + fileNameSuffix;
                    link.href = URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                } else {
                    navigator.msSaveBlob(blob);
                }

                setTimeout(() => setWordExportLoading(false), 2000);
            })
            .catch(err => {
                message.error('导出失败');
                setWordExportLoading(false);
            });
    };

    const onChangeSpecInstruction = e => {
        console.log(e.target.checked);
        setSpecInstructionEnabled(e.target.checked);
    };

    const getPlacesOverview = async () => {
        setLoadingPlacesOverview(true);
        const res = await getConferencePlacesOverview({ conferenceId });
        if (res.status_code === 200) {
            console.log('PlacesOverviewData', res.data);
            const placesData = preparePlacesOverviewData(res.data);
            setPlacesOverviewData(placesData);
            setLoadingPlacesOverview(false);
        } else {
            setLoadingPlacesOverview(false);
        }
    };

    const preparePlacesOverviewData = placesData => {
        console.log('placesData', placesData);
        const data = [...placesData];

        const result = {
            dates: [],
            places: [],
        };

        data.forEach(place => {
            let placeHallNum = 0; // 某个会议地点会议场次的数量
            place.agendas.forEach(agenda => {
                placeHallNum += agenda.halls.filter(h => h.hidden === '0').length;
                if (result.dates.some(d => d.date === agenda.day)) {
                    // 日期已存在
                    result.dates = result.dates.map(d => {
                        if (d.date === agenda.day) {
                            return { ...d, hallNum: d.hallNum + agenda.halls.filter(h => h.hidden === '0').length };
                        } else {
                            return d;
                        }
                    });
                } else {
                    // 新日期
                    result.dates.push({
                        date: agenda.day,
                        hallNum: agenda.halls.filter(h => h.hidden !== '1').length,
                    });
                }
            });
            result.places.push({ ...place, hallNum: placeHallNum });
        });

        console.log('preparePlacesOverviewData', result);
        return result;
    };

    const exportHtmlDomAsImage = async (el, imageFileName) => {
        const canvas = await html2canvas(el, { useCORS: true });

        const link = document.createElement('a');
        link.style.display = 'none';
        link.download = imageFileName;
        link.href = canvas.toDataURL('image/png', 1.0);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        link.remove();
    };

    const downloadPlacesOverviewExcel = () => {
        // 项目特别说明 spec：1导出项目特别说明，0不导出
        // 是否导出隐藏会议场次 hidden：0不导出隐藏，1导出隐藏
        const params = {
            conferenceId,
            spec: specInstructionEnabled ? 1 : 0,
            hidden: 0, //
        };

        get('/conference/boss/conferenceplaces/excel-export/download', params, { responseType: 'blob' }).then(res => {
            message.success('请稍后，正在导出');

            const blob = new Blob([res], { type: 'application/octet-stream' });
            if ('download' in document.createElement('a')) {
                const fileNameSuffix = '_' + dayjs().format('YYYYMMDDHHmmss') + '.xlsx';

                const link = document.createElement('a');
                link.style.display = 'none';
                link.download = '会议信息一览_' + conference.name + fileNameSuffix;
                link.href = URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                link.remove();
            } else {
                navigator.msSaveBlob(blob);
            }
        });
    };

    const downloadPlacesOverviewImage = () => {
        const el = document.getElementById('places-overview-table-box');
        const fileName = conference.name + '.png';
        exportHtmlDomAsImage(el, fileName);
    };

    const openPlacesOverviewModal = () => {
        setVisiblePlacesOverviewModal(true);
        getPlacesOverview();
    };

    const closePlaceOverviewModal = () => {
        setVisiblePlacesOverviewModal(false);
    };

    const requestAllStaffs = useCallback(async () => {
        const res = await getBossStaffs();
        if (res.status_code === 200) {
            setStaffs(res.data);
            console.log('staffs', res.data);
        }
    }, []);

    // 企业负责人
    const requestAllEnterprisePerson = useCallback(async () => {
        const res = await getAllEnterpriseApi({ conferenceId, page: 1, pageSize: 9999, role: 3 });
        if (res.status_code === 200 && res.data) {
            setEnterprisePerson(res.data.list);
        }
    }, [conferenceId]);

    const getConferenceInfo = async conferenceId => {
        const res = await conferenceOnceApi({ id: conferenceId });
        if (res.status_code === 200) {
            setConference(res.data);
            setLaborFeeConfirmed(!!res.data?.laborFeeConfirmedAt);
        }
    };

    useEffect(() => {
        if (!!conferenceId) {
            getConferenceInfo(conferenceId);
        }
    }, [conferenceId]);

    const showAddConferenceHallDrawer = item => {
        if (item) {
            setConferenceDetail(item);
        } else {
            setConferenceDetail(null);
        }
        setVisibleAddConferenceHallDrawer(true);
    };

    // 新增/编辑日程 Drawer
    const [visibleAddAgendaDrawer, setVisibleAddAgendaDrawer] = useState(false);
    const [hallOperationLogOpen, setHallOperationLogOpen] = useState(false);
    const [agendasData, setAgendasData] = useState([]);
    const [agendaDetail, setAgendaDetail] = useState(null);

    const showAddAgendaDrawer = item => {
        if (item) {
            setAgendaDetail(item);
        } else {
            setAgendaDetail(item);
        }

        setVisibleAddAgendaDrawer(true);
    };

    // 当前选中会议
    const checkConference = hall => {
        setCurrentConferenceHall(hall);
        if (hall.sponsorOrgId) {
            getOrganisationinfoApi({ id: hall.sponsorOrgId }).then(res => {
                if (res.status_code === 200 && res.data) {
                    setSponsorHosName(res.data.hosName);
                } else {
                    setSponsorHosName('');
                }
            });
        } else {
            setSponsorHosName('');
        }
    };

    // 会议删除
    const deleteConference = id => {
        getAgendasListApi({ hallsId: id }).then(res => {
            let modalContent = <span>是否确认删除当前会议</span>;

            if (res.status_code === 200 && res.data && res.data.length > 0) {
                modalContent = (
                    <div>
                        <span>是否确认删除当前会议及所有日程</span>
                        <br />
                        <span style={{ color: 'red' }}>会议及会议下的所有日程都将被删除，请谨慎操作。</span>
                    </div>
                );
            }

            Modal.confirm({
                title: '提示',
                content: modalContent,
                cancelText: '取消',
                okText: '确认',
                closable: true,
                onOk: async () => {
                    const res = await deleteConferenceApi({ id });
                    if (res.status_code === 200) {
                        message.success('删除成功');
                        getConferenceList();
                    }
                },
            });
        });
    };

    // 日程删除
    const deleteAgenda = id => {
        Modal.confirm({
            title: '提示',
            content: '是否确认删除当前日程',
            cancelText: '取消',
            okText: '确认',
            closable: true,
            onOk: async () => {
                const res = await deleteAgendaApi({ id });
                if (res.status_code === 200) {
                    message.success('删除成功');
                    getAgendasList(currentConferenceHall?.id);
                }
            },
        });
    };

    // 显示/隐藏会议
    const changeConferenceHallStatus = async data => {
        const res = await changeConferenceHallStatusApi(data);
        if (res.status_code === 200) {
            getConferenceList();
            message.success(data.hidden ? '隐藏会议成功' : '显示会议成功');
        }
    };

    // 显示/隐藏日程/日程嘉宾
    const changeAgendaAndGuestsStatus = async (type, data) => {
        // TODO 需要重构，逻辑有重叠
        // 日程显示检查
        if (type === 'agenda_status') {
            const res = await changeAgendaAndGuestsStatusApi({ ...data, check: 1 });
            const msg = data?.hidden === 1 ? '隐藏日程成功' : '显示日程成功';
            if (res.status_code === 200) {
                message.success(msg);
                getAgendasList(currentConferenceHall?.id);
            } else if (res.status_code === 422) {
                Modal.confirm({
                    title: '提示',
                    icon: <i className="bi bi-exclamation-circle"></i>,
                    content: `该日程下暂未添加嘉宾，确认更改为显示状态？`,
                    okText: '确认显示',
                    centered: true,
                    cancelText: '暂不显示',
                    onOk: async () => {
                        const res = await changeAgendaAndGuestsStatusApi({ ...data, check: 2 });
                        if (res.status_code === 200) {
                            message.success(msg);
                            getAgendasList(currentConferenceHall?.id);
                        }
                    },
                });
            }
        } else {
            const res = await changeAgendaAndGuestsStatusApi(data);
            if (res.status_code === 200) {
                // 提示信息
                let msg = '';
                if (type === 'agenda_status') {
                    msg = data?.hidden === 1 ? '隐藏日程成功' : '显示日程成功';
                } else if (type === 'guests_status') {
                    msg = data?.guestsHidden === 1 ? '隐藏日程嘉宾成功' : '显示日程嘉宾成功';
                }
                message.success(msg);
                getAgendasList(currentConferenceHall?.id);
            }
        }
    };

    // 会议排序请求接口
    const sortConference = async data => {
        const ids = [];
        data.forEach(item => {
            ids.push(item.id);
            if (item.secondHallsList?.length) {
                item.secondHallsList.forEach(sec => {
                    ids.push(sec.id);
                });
            }
        });

        const res = await sortConferenceApi({
            resList: [{ ids: ids }],
            conferenceId,
        });
        if (res?.status_code === 200) {
            getConferenceList();
        }
    };

    // 一级会议拖拽结束（@dnd-kit，替代 react-sortable-hoc，避免 findDOMNode 弃用警告）
    const onDragEndMainHalls = useCallback(
        event => {
            const { active, over } = event;
            if (!over || active.id === over.id) {
                return;
            }
            const dateKey = currentDate.current;
            if (!dateKey) {
                return;
            }
            setConferenceData(prev => {
                const items = prev[dateKey];
                if (!items) {
                    return prev;
                }
                const oldIndex = items.findIndex(it => it.id === active.id);
                const newIndex = items.findIndex(it => it.id === over.id);
                if (oldIndex === -1 || newIndex === -1) {
                    return prev;
                }
                const newArr = arrayMoveImmutable(items, oldIndex, newIndex);
                sortConference(newArr);
                return { ...prev, [dateKey]: newArr };
            });
        },
        [sortConference],
    );

    // 二级会议拖拽结束
    const onDragEndNestedHalls = useCallback(
        parentId => event => {
            const { active, over } = event;
            if (!over || active.id === over.id) {
                return;
            }
            const dateKey = currentDate.current;
            if (!dateKey) {
                return;
            }
            setConferenceData(prev => {
                const items = prev[dateKey];
                if (!items) {
                    return prev;
                }
                const ind = items.findIndex(it => it.id === parentId);
                if (ind === -1) {
                    return prev;
                }
                const secItems = items[ind].secondHallsList;
                if (!secItems?.length) {
                    return prev;
                }
                const oldIndex = secItems.findIndex(s => s.id === active.id);
                const newIndex = secItems.findIndex(s => s.id === over.id);
                if (oldIndex === -1 || newIndex === -1) {
                    return prev;
                }
                const newSec = arrayMoveImmutable(secItems, oldIndex, newIndex);
                const newItems = [...items];
                newItems[ind] = { ...items[ind], secondHallsList: newSec };
                const newData = { ...prev, [dateKey]: newItems };
                sortConference(newData[dateKey]);
                return newData;
            });
        },
        [sortConference],
    );

    // 日程拖拽结束
    const onDragEndAgendas = useCallback(
        event => {
            const { active, over } = event;
            if (!over || active.id === over.id) {
                return;
            }
            setAgendasData(prev => {
                const oldIndex = prev.findIndex(a => a.id === active.id);
                const newIndex = prev.findIndex(a => a.id === over.id);
                if (oldIndex === -1 || newIndex === -1) {
                    return prev;
                }
                const beforeIds = prev.map(i => i.id);
                const res = arrayMoveImmutable(prev, oldIndex, newIndex);
                const afterIds = res.map(i => i.id);
                const hallId = currentConferenceHall?.id;
                const hallName = currentConferenceHall?.name;
                void sortAgendaApi({ resList: [{ ids: afterIds }], conferenceId })
                    .then(sortRes => {
                        if (sortRes?.status_code === 200) {
                            void logAgendaReorder({ hallId, hallName, beforeIds, afterIds, isSuccess: true }).catch(e => console.error('操作日志上报失败', e));
                        } else {
                            void logAgendaReorder({
                                hallId,
                                hallName,
                                beforeIds,
                                afterIds,
                                isSuccess: false,
                                errorMessage: sortRes?.message,
                            }).catch(e => console.error('操作日志上报失败', e));
                        }
                    })
                    .catch(err => {
                        void logAgendaReorder({
                            hallId,
                            hallName,
                            beforeIds,
                            afterIds,
                            isSuccess: false,
                            errorMessage: err?.message,
                        }).catch(e => console.error('操作日志上报失败', e));
                    });
                return [...res];
            });
        },
        [conferenceId, currentConferenceHall?.id, currentConferenceHall?.name],
    );

    // 会议论坛列表，用于快速定位会议（场次）
    const prepareConferenceHallTreeData = data => {
        const treeData = [];
        let checkedKeys = [];

        if (Object.keys(data)?.length) {
            Object.keys(data).forEach(agendaDate => {
                const dateNode = {
                    title: agendaDate,
                    value: agendaDate,
                    selectable: false,
                    hallNum: 0,
                    children: [],
                };

                // checkedKeys.push(agendaDate);

                const confHalls = data[agendaDate];
                confHalls?.length
                    && confHalls.forEach(confHall => {
                        const hallNode = {
                            title: confHall.hidden ? `${confHall.name} [YHYC#${confHall.id}]【隐藏中】` : `${confHall.name} [YHYC#${confHall.id}]`,
                            value: confHall.id,
                            hidden: confHall.hidden,
                            // disableCheckbox: confHall.hidden,
                            children: [],
                            wordHostName: `主持稿_YHYC#${confHall.id}_${confHall.name}.docx`,
                        };

                        if (!confHall.hidden) {
                            checkedKeys.push(confHall.id);
                        }

                        const confSubHalls = confHall.secondHallsList || [];
                        if (confSubHalls?.length) {
                            hallNode.selectable = false;

                            confSubHalls.forEach(subHall => {
                                dateNode.hallNum += 1;

                                hallNode.children.push({
                                    title: subHall.hidden ? `${subHall.name} [YHYC#${subHall.id}]【隐藏中】` : `${subHall.name} [YHYC#${subHall.id}]`,
                                    value: subHall.id,
                                    hidden: subHall.hidden,
                                    // disableCheckbox: subHall.hidden,
                                });

                                if (!subHall.hidden) {
                                    checkedKeys.push(subHall.id);
                                } else {
                                    // 父级 id 不添加到 checkedKeys 中
                                    checkedKeys = checkedKeys.filter(k => k !== confHall.id);
                                }
                            });
                        } else {
                            dateNode.hallNum += 1;
                        }

                        dateNode.children.push(hallNode);
                    });

                treeData.push(dateNode);
            });
        }

        console.log('checkedKeys', checkedKeys);

        setCheckedConfHallKeys(checkedKeys);

        setSelectedConfHallKeys(checkedKeys.filter(k => typeof k === 'number'));

        console.log('treeData', treeData);
        return treeData;
    };

    // 获取会议列表
    const getConferenceList = useCallback(async () => {
        const res = await getConferenceListApi({ conferenceId });
        if (res.status_code === 200) {
            const agendaData = res.data;
            console.log('agendaData', agendaData);
            setConferenceData(agendaData);
            setConferenceHallTreeData(prepareConferenceHallTreeData(agendaData));

            if (!_.isEmpty(agendaData)) {
                const agendaDates = Object.keys(agendaData);
                if (!currentDate.current) {
                    if (agendaDates?.length) {
                        currentDate.current = agendaDates[0];
                        setTabActiveKey(agendaDates[0]);
                    } else {
                        currentDate.current = null;
                        setTabActiveKey('');
                    }
                }

                console.log('agendaDates', agendaDates);
                setDateList(agendaDates);
            }
        }
    }, [conferenceId]);

    // 会议tab切换
    const onChangeTabs = value => {
        currentDate.current = value;
    };

    // 查询日程列表
    const getAgendasList = async checkId => {
        const res = await getAgendasListApi({ hallsId: checkId });
        if (res.status_code === 200) {
            setAgendasData(res.data);
            getSortTotal(checkId);
        }
    };

    // 获取排序方式名称
    const getSortModeName = type => {
        if (type === 1) {
            return '按姓氏拼音排序';
        }
        if (type === 2) {
            return '按姓氏笔画排序';
        }
        if (type === 0) {
            return '';
        }
    };

    const isEmptyAgenda = useMemo(() => {
        return !!(currentConferenceHall && (!agendasData || !agendasData.length));
    }, [currentConferenceHall, agendasData]);

    // 是否有调整会议日期权限
    const canChangeConfHallDate = useMemo(() => {
        const roleList = localStorageGet('roleList') ? JSON.parse(localStorageGet('roleList')) : [];
        if (roleList?.length) {
            return roleList.some(item => item.name === '调整会议日程');
        }
        return false;
    }, []);

    useEffect(() => {
        getConferenceList(); // 会议信息
        requestAllStaffs(); // 员工信息
        requestAllEnterprisePerson(); // 企业负责人信息
    }, []);

    useEffect(() => {
        if (currentConferenceHall) {
            console.log(currentConferenceHall);
            getAgendasList(currentConferenceHall.id);
            // 切换会议场次时重置展开状态
            setAgendaSummaryExpanded(false);
            setProjectInstructionsExpanded(false);
        }
    }, [currentConferenceHall]);

    // 检测内容是否需要展开/收起功能
    useEffect(() => {
        const checkOverflow = () => {
            if (agendaSummaryRef.current) {
                const element = agendaSummaryRef.current;
                setShowAgendaSummaryToggle(element.scrollHeight > element.clientHeight);
            }

            if (projectInstructionsRef.current) {
                const element = projectInstructionsRef.current;
                setShowProjectInstructionsToggle(element.scrollHeight > element.clientHeight);
            }
        };

        // 延迟检测，确保 DOM 已渲染完成
        const timer = setTimeout(checkOverflow, 100);

        return () => clearTimeout(timer);
    }, [currentConferenceHall?.agendaSummary, currentConferenceHall?.projectSpecificInstructions]);

    // 初始化Word模板设置
    useEffect(() => {
        if (visibleExportPrintAgendaModal && conference?.agendaSettings) {
            const agendaSettings = JSON.parse(conference.agendaSettings);
            wordTemplateForm.setFieldsValue({
                print: {
                    conf_hall_title_background_color: agendaSettings?.print?.conf_hall_title_background_color,
                    conf_hall_title_secondary_background_color: agendaSettings?.print?.conf_hall_title_secondary_background_color,
                    new_page_per_conf_hall: agendaSettings?.print?.new_page_per_conf_hall || false,
                },
            });
        }
    }, [visibleExportPrintAgendaModal, conference, wordTemplateForm]);

    const [visiblePreviewAgendasDrawer, setVisiblePreviewAgendasDrawer] = useState(false);
    const previewAgendas = () => {
        setVisiblePreviewAgendasDrawer(true);
    };

    // 通过会议ID获取会议信息
    const getConferenceHallById = id => {
        let conferenceHall = null;

        Object.keys(conferenceData)?.length
            && Object.keys(conferenceData).forEach(agendaDate => {
                conferenceData[agendaDate].forEach(hall => {
                    if (hall.id === id) {
                        conferenceHall = hall;
                    } else {
                        hall.secondHallsList?.length
                            && hall.secondHallsList.forEach(subHall => {
                                if (subHall.id === id) {
                                    conferenceHall = subHall;
                                }
                            });
                    }
                });
            });

        return conferenceHall;
    };

    // 快速定位论坛-选中论坛
    const onChangeConferenceHall = value => {
        if (!!value) {
            conferenceHallTreeData?.forEach(agendaDate => {
                agendaDate?.children?.forEach(hall => {
                    if (hall.value === value) {
                        currentDate.current = agendaDate.value;

                        // 切换 Tab
                        setTabActiveKey(agendaDate.value);
                        console.log(agendaDate.value);
                    } else {
                        hall?.children?.forEach(subHall => {
                            if (subHall.value === value) {
                                currentDate.current = agendaDate.value;

                                // 切换 Tab
                                setTabActiveKey(agendaDate.value);
                                console.log(agendaDate.value);
                            }
                        });
                    }
                });
            });

            // 选中论坛
            setCurrentConferenceHall(getConferenceHallById(value));

            // 滚动到选中的会议论坛
            setTimeout(() => {
                const selectedHall = document.querySelector('.halls-hall.hall-selected');

                if (selectedHall) {
                    // 使用 scrollIntoView 实现滚动，更可靠
                    selectedHall.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center', // 让元素在视窗中居中
                        inline: 'nearest',
                    });
                }
            }, 300); // 增加延迟时间，等待 Tab 切换和 DOM 更新完成
        } else {
            // setTabActiveKey(conferenceHallTreeData[0].value);
        }
    };

    const onTabClick = key => setTabActiveKey(key);

    const clearConferenceAgendasCache = async () => {
        const data = {
            type: 'conference',
            key: `conference_${conferenceId}_user_agendas`,
        };
        const res = await deleteConferenceCache(data);
        if (res?.status_code === 200) {
            message.success('更新会议官网日程成功！');
        }
    };

    const onClearConferenceAgendasCache = () => {
        if (conferenceId) {
            Modal.confirm({
                title: '更新会议官网日程',
                icon: <i className="bi bi-exclamation-circle"></i>,
                width: 480,
                centered: true,
                content: (
                    <>
                        <p>为减轻性能压力，系统自动缓存数据，该功能将更新用户端数据，展现最新设定内容。</p>
                        <p>
                            <Typography.Text type="danger">会议进行期间谨慎更新！</Typography.Text>
                        </p>
                    </>
                ),
                onOk() {
                    clearConferenceAgendasCache();
                },
                cancelText: '取消，暂不更新',
                okText: '知晓，确认更新',
            });
        }
    };

    // 调整会议日期 Modal
    const [visibleChangeConferenceDateModal, setVisibleChangeConferenceDateModal] = useState(false);
    const [currentChangeConferenceHall, setCurrentChangeConferenceHall] = useState(null);
    // 日程下载弹框
    const [visibleDownloadAgenda, setVisibleDownloadAgenda] = useState(false);
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [printAgendaUrl, setPrintAgendaUrl] = useState('');

    // 会议概要和项目特别说明的展开状态
    const [agendaSummaryExpanded, setAgendaSummaryExpanded] = useState(false);
    const [projectInstructionsExpanded, setProjectInstructionsExpanded] = useState(false);

    // 判断内容是否需要展开/收起功能
    const [showAgendaSummaryToggle, setShowAgendaSummaryToggle] = useState(false);
    const [showProjectInstructionsToggle, setShowProjectInstructionsToggle] = useState(false);

    const agendaSummaryRef = useRef(null);
    const projectInstructionsRef = useRef(null);

    // 日程列表容器的ref
    const agendasRef = useRef(null);

    // 动态计算并设置容器高度
    const updateContainerHeights = useCallback(() => {
        // 更新会议列表容器高度（.halls）
        const hallsElements = document.querySelectorAll('.conference-halls-area .halls');
        hallsElements.forEach(hallsEl => {
            const rect = hallsEl.getBoundingClientRect();
            const maxHeight = window.innerHeight - rect.top - 20; // 减去一些底部边距
            hallsEl.style.maxHeight = `${maxHeight}px`;
        });

        // 更新日程列表容器高度（.agendas）
        if (agendasRef.current) {
            const rect = agendasRef.current.getBoundingClientRect();
            const maxHeight = window.innerHeight - rect.top - 20; // 减去一些底部边距
            agendasRef.current.style.maxHeight = `${maxHeight}px`;
        }
    }, []);

    // 监听窗口大小变化
    useEffect(() => {
        // 初始计算时也使用延迟，确保 DOM 已渲染
        const timer = setTimeout(() => {
            updateContainerHeights();
        }, 100);

        // 监听 resize 事件
        window.addEventListener('resize', updateContainerHeights);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', updateContainerHeights);
        };
    }, [updateContainerHeights]);

    // 当会议数据或日程数据变化时，重新计算高度
    useEffect(() => {
        // 使用 setTimeout 确保 DOM 已经更新
        const timer = setTimeout(() => {
            updateContainerHeights();
        }, 100);

        return () => clearTimeout(timer);
    }, [conferenceData, agendasData, currentConferenceHall, updateContainerHeights]);

    // 当 Tab 切换时，重新计算高度
    useEffect(() => {
        const timer = setTimeout(() => {
            updateContainerHeights();
        }, 100);

        return () => clearTimeout(timer);
    }, [tabActiveKey, updateContainerHeights]);

    // 当全屏状态切换时，重新计算高度
    useEffect(() => {
        const timer = setTimeout(() => {
            updateContainerHeights();
        }, 100);

        return () => clearTimeout(timer);
    }, [isFullscreen, updateContainerHeights]);

    // 显示调整会议日期Modal
    const showChangeConferenceDateModal = conferenceHall => {
        setCurrentChangeConferenceHall(conferenceHall);
        setVisibleChangeConferenceDateModal(true);
    };

    // 关闭调整会议日期Modal
    const closeChangeConferenceDateModal = () => {
        setVisibleChangeConferenceDateModal(false);
        setCurrentChangeConferenceHall(null);
    };

    // 调整会议日期成功回调
    const onChangeConferenceDateSuccess = () => {
        getConferenceList(); // 重新获取会议列表
        // 如果当前选中的会议被调整了日期，需要重新选择
        if (currentChangeConferenceHall && currentConferenceHall?.id === currentChangeConferenceHall.id) {
            setCurrentConferenceHall(null);
        }
    };

    // 下载日程
    const downloadPrintAgenda = async () => {
        const url = `${getFileUrl(conference?.agendaPrintUrl || printAgendaUrl)}?t=${new Date().getTime()}`;
        fetch(url).then(res => {
            res.blob().then(blob => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = blobUrl;
                a.download = conference?.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(blobUrl);
            });
        });
    };

    // 重新生成日程
    const redoGenerate = async () => {
        setShowPrintModal(true);
        const res = await pdfExportDownloadApi({ conferenceId });
        await getConferenceInfo(conferenceId);
        setShowPrintModal(false);
        if (res.status_code === 200) {
            setPrintAgendaUrl(res.data);
        }
    };

    // 导出Excel
    const exportAgendas = (data = {}) => {
        const params = { ...data, conferenceId };

        get('/conference/boss/agendas/excel-export/download', params, { responseType: 'blob' }).then(res => {
            message.success('请稍后，正在导出');

            const content = res;
            const blob = new Blob([content], { type: 'application/octet-stream' });
            if ('download' in document.createElement('a')) {
                // let fileNameSuffix = '';
                // if (!!data && 'completed' in data) {
                //     params = { ...params, completed: data.completed };
                //     fileNameSuffix = !!data.completed ? '_完备日程' : '_缺失日程';
                // }
                const fileNameSuffix = `_${dayjs().format('YYYYMMDDHHmmss')}.xlsx`;

                const link = document.createElement('a');
                link.style.display = 'none';
                link.download = `日程表格_${conference.name}${fileNameSuffix}`;
                link.href = URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                link.remove();
            } else {
                navigator.msSaveBlob(blob);
            }
        });
    };

    // Word主持稿弹框Modal
    const openExportPrintHost = () => {
        setVisibleExportPrintHost(true);
    };

    const closeExportPrintHost = () => {
        setVisibleExportPrintHost(false);
    };

    // 导出Word主持稿
    const exportPrintHost = () => {
        if (currentHostConfHallKey?.length) {
            const params = {
                conferenceId: conferenceId,
                hallId: currentHostConfHallKey[0],
            };
            const url = '/conference/boss/conferencehalls/moderator-script-word-download';
            get(url, params, { responseType: 'blob' })
                .then(res => {
                    message.success('请稍后，正在导出');

                    const blob = new Blob([res], { type: 'application/octet-stream' });
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.style.display = 'none';
                        link.download = currentHostConfHallRef.current;
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        link.remove();
                    } else {
                        navigator.msSaveBlob(blob);
                    }
                })
                .catch(err => {
                    message.error('导出失败');
                });
        } else {
            message.error('请选择导出的会议场次');
        }
    };

    // 选择导出的word主持稿的会议和会场
    const onChangeConfHall = (value, info) => {
        setCurrentHostConfHallKey(value);
        currentHostConfHallRef.current = info?.node?.wordHostName;
    };

    // 刷新
    const handleRefresh = async () => {
        try {
            console.log('开始刷新数据...');

            // 并行获取会议基本信息和会议场次列表
            const promises = [getConferenceInfo(conferenceId), getConferenceList()];

            await Promise.all(promises);

            // 如果有选中的会议场次，重新获取其日程列表
            if (currentConferenceHall?.id) {
                await getAgendasList(currentConferenceHall.id);
                console.log('已刷新选中场次的日程数据:', currentConferenceHall.name);
            }

            console.log('数据刷新完成');
            message.success('数据已刷新');
        } catch (error) {
            console.error('刷新数据时出错:', error);
            message.error('刷新失败，请重试');
        }
    };

    // 日程导出下拉菜单
    const agendaExportMenuItems = [
        {
            key: 'export-word-agenda',
            label: '导出Word版日程',
            onClick: openExportPrintAgendaModal,
        },
        {
            key: 'export-h5-agenda',
            label: '导出H5版日程',
            onClick: () => previewAgendas(),
        },
        {
            key: 'export-excel-agenda',
            label: '导出Excel版日程',
            onClick: () => exportAgendas(),
        },
    ];

    useEffect(() => {
        document.title = '会议日程-医会议';
    }, []);

    return (
        <>
            <PageHeader title="会议日程" breadcrumb={[{ label: '医会议', path: CONFERENCE_WORKSPACE_PARENT_PATH }, { label: conference?.name || '项目信息', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}` }, '会议日程']} />

            <div className="page-route-body agenda-list">
                <div className="main-content-body">
                    <div className="conference-header-btn">
                        <Space>
                            <Button onClick={() => openPlacesOverviewModal()}>会议信息一览</Button>
                            <Button danger onClick={() => onClearConferenceAgendasCache()}>
                                更新官网日程
                            </Button>
                        </Space>

                        <Space>
                            <Tooltip title="导出Word版主持稿">
                                <Button onClick={openExportPrintHost}>导出主持稿</Button>
                            </Tooltip>

                            <Dropdown menu={{ items: agendaExportMenuItems }} placement="bottomLeft">
                                <Button>
                                    导出日程 <i className="bi bi-chevron-down"></i>
                                </Button>
                            </Dropdown>

                            <Tooltip title="刷新会议日程数据">
                                <Button
                                    type="default"
                                    icon={
                                        <span className="anticon">
                                            <i className="bi bi-arrow-clockwise"></i>
                                        </span>
                                    }
                                    onClick={handleRefresh}
                                />
                            </Tooltip>

                            <Tooltip title={isFullscreen ? '退出全屏' : '全屏'}>
                                <Button
                                    type="default"
                                    icon={
                                        <span className="anticon">
                                            <i className={`bi ${isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'}`}></i>
                                        </span>
                                    }
                                    onClick={handleToggleFullscreen}
                                />
                            </Tooltip>
                        </Space>
                    </div>

                    <Row gutter={24} className="agenda-content">
                        <Col span={12}>
                            <div className="conference-halls-area">
                                <div className="conference-halls-title">
                                    <h2>
                                        <span style={{ verticalAlign: 'middle' }}>会议</span>
                                        {!isEmpty(conferenceHallTreeData) && Array.isArray(conferenceHallTreeData) && <small>({conferenceHallTreeData?.reduce((accumulator, currentValue) => accumulator + currentValue.hallNum, 0)}场)</small>}

                                        <PopoverTip
                                            placement="right"
                                            content={
                                                <>
                                                    所有会议论坛一经创建即生成唯一编号，如 YHYC#123， <br />
                                                    无论删除与否，该编号均不重复。{' '}
                                                </>
                                            }
                                        >
                                            <i className="bi bi-question-circle-fill popover-tip-icon"></i>
                                        </PopoverTip>
                                    </h2>
                                    <div className="btns">
                                        <Space>
                                            <TreeSelect
                                                showSearch={{ filterTreeNode: filterTreeNodeByTitle }}
                                                style={{ width: 200 }}
                                                styles={{ popup: { root: { minWidth: 500, overflow: 'auto' } } }}
                                                allowClear
                                                treeDefaultExpandAll
                                                placement="bottomLeft"
                                                onChange={onChangeConferenceHall}
                                                treeData={conferenceHallTreeData}
                                                placeholder="快速定位会议论坛"
                                            />

                                            <Button onClick={() => showAddConferenceHallDrawer()}>新增会议</Button>
                                        </Space>
                                    </div>
                                </div>

                                <div className="conference-halls">
                                    <Tabs
                                        onChange={onChangeTabs}
                                        size="small"
                                        type="card"
                                        activeKey={tabActiveKey}
                                        onTabClick={onTabClick}
                                        items={
                                            Object.keys(conferenceData)?.length
                                                ? Object.keys(conferenceData).map(item => {
                                                      return {
                                                          label: `${item} (${conferenceHallTreeData?.find(h => h.value === item)?.hallNum}场)`,
                                                          key: item,
                                                          children: (
                                                              <div className="halls">
                                                                  <DndContext sensors={dndSensors} collisionDetection={closestCenter} onDragEnd={onDragEndMainHalls}>
                                                                      <SortableContext items={(conferenceData[item] || []).map(h => h.id)} strategy={verticalListSortingStrategy}>
                                                                          <div>
                                                                              {(conferenceData[item] || []).map(treeNode => (
                                                                                  <SortableMainHallRow
                                                                                      key={treeNode.id}
                                                                                      treeNode={treeNode}
                                                                                      laborFeeConfirmed={laborFeeConfirmed}
                                                                                      staffs={staffs}
                                                                                      currentConferenceHall={currentConferenceHall}
                                                                                      canChangeConfHallDate={canChangeConfHallDate}
                                                                                      dateList={dateList}
                                                                                      showAddConferenceHallDrawer={showAddConferenceHallDrawer}
                                                                                      changeConferenceHallStatus={changeConferenceHallStatus}
                                                                                      deleteConference={deleteConference}
                                                                                      checkConference={checkConference}
                                                                                      showChangeConferenceDateModal={showChangeConferenceDateModal}
                                                                                      dndSensors={dndSensors}
                                                                                      onDragEndNestedHalls={onDragEndNestedHalls}
                                                                                  />
                                                                              ))}
                                                                          </div>
                                                                      </SortableContext>
                                                                  </DndContext>
                                                              </div>
                                                          ),
                                                      };
                                                  })
                                                : []
                                        }
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div className="agenda-area">
                                <div className="agendas-title">
                                    <h2>日程</h2>
                                    <div className="agenda-operations">
                                        <Space>
                                            <Button onClick={() => showAddAgendaDrawer()} disabled={!currentConferenceHall?.id}>
                                                新增日程
                                            </Button>
                                            <Dropdown
                                                placement="bottomRight"
                                                trigger={['hover']}
                                                disabled={!currentConferenceHall?.id}
                                                menu={{
                                                    items: [{ label: '操作记录', key: 'operation-log' }],
                                                    onClick: ({ key }) => {
                                                        if (key === 'operation-log') {
                                                            setHallOperationLogOpen(true);
                                                        }
                                                    },
                                                }}
                                            >
                                                <Button icon={<i className="bi bi-three-dots" aria-hidden="true" />} disabled={!currentConferenceHall?.id} />
                                            </Dropdown>
                                        </Space>
                                    </div>
                                </div>

                                {!!currentConferenceHall && (
                                    <div className="current-hall">
                                        <span>
                                            {currentConferenceHall?.name} <small>YHYC#{currentConferenceHall?.id}</small>
                                        </span>
                                    </div>
                                )}

                                {(!!currentConferenceHall?.agendaSummary || !!currentConferenceHall?.implementers || !!currentConferenceHall?.sponsorInfo) && (
                                    <Alert
                                        type="warning"
                                        style={{ marginBottom: 16 }}
                                        title={
                                            <div className="conf-extra">
                                                {!!currentConferenceHall?.agendaSummary && (
                                                    <div className="agenda-summary-wrapper">
                                                        <div ref={agendaSummaryRef} className={`agenda-summary ${agendaSummaryExpanded ? 'expanded' : ''}`}>
                                                            <b>会议概要：</b>
                                                            {currentConferenceHall.agendaSummary}
                                                        </div>
                                                        {showAgendaSummaryToggle && (
                                                            <span className="toggle-icon" onClick={() => setAgendaSummaryExpanded(!agendaSummaryExpanded)}>
                                                                <i className={`bi ${agendaSummaryExpanded ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
                                                            </span>
                                                        )}
                                                    </div>
                                                )}

                                                {!!currentConferenceHall?.projectSpecificInstructions && (
                                                    <div className="project-specific-instructions-wrapper">
                                                        <div ref={projectInstructionsRef} className={`project-specific-instructions ${projectInstructionsExpanded ? 'expanded' : ''}`}>
                                                            <b>项目特别说明：</b>
                                                            {currentConferenceHall.projectSpecificInstructions}
                                                        </div>
                                                        {showProjectInstructionsToggle && (
                                                            <span className="toggle-icon" onClick={() => setProjectInstructionsExpanded(!projectInstructionsExpanded)}>
                                                                <i className={`bi ${projectInstructionsExpanded ? 'bi-caret-up-fill' : 'bi-caret-down-fill'}`}></i>
                                                            </span>
                                                        )}
                                                    </div>
                                                )}

                                                {(!!currentConferenceHall?.implementers || !!currentConferenceHall?.sponsorInfo) && (
                                                    <div className="extra">
                                                        {!!currentConferenceHall?.implementers && (
                                                            <span className="implementers">
                                                                <b>项目执行人：</b>
                                                                {currentConferenceHall.implementers
                                                                    .split(',')
                                                                    .filter(d => d !== '0')
                                                                    .map(i => staffs.find(s => s.id === parseInt(i)).name)
                                                                    .join('、')}
                                                            </span>
                                                        )}
                                                        {!!sponsorHosName && (
                                                            <span className="sponsor-info">
                                                                <b>赞助企业：</b>
                                                                {sponsorHosName}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                    />
                                )}
                                {currentConferenceHall && !isEmptyAgenda && (
                                    <div>
                                        <span style={{ marginRight: 16 }}>拟邀专家：{sortInfo.expertsCount}人</span>
                                        桌签排序：
                                        {sortInfo.sortStatus === 1 && <Typography.Text type="success">已排序</Typography.Text>}
                                        {sortInfo.sortStatus === 2 && <Typography.Text type="warning">未排序</Typography.Text>}
                                        {sortInfo.sortStatus === 3 && <Typography.Text type="warning">部分排序</Typography.Text>}{' '}
                                        <Button type="link" onClick={openSeatingArrangementModal}>
                                            立即排序
                                        </Button>
                                    </div>
                                )}

                                <div className="agendas" ref={agendasRef}>
                                    {!currentConferenceHall && (
                                        <Empty
                                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                                            description={
                                                <span>
                                                    <i className="bi bi-arrow-left"></i> 请先新增并选择会议
                                                </span>
                                            }
                                        />
                                    )}

                                    {isEmptyAgenda && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="该会议下暂无日程" />}

                                    {currentConferenceHall && !isEmptyAgenda ? (
                                        <DndContext sensors={dndSensors} collisionDetection={closestCenter} onDragEnd={onDragEndAgendas}>
                                            <SortableContext items={agendasData.map(a => a.id)} strategy={verticalListSortingStrategy}>
                                                <div>
                                                    {agendasData.map(agendasItem => (
                                                        <AgendaSortableRow key={agendasItem.id} agendasItem={agendasItem} getSortModeName={getSortModeName} showAddAgendaDrawer={showAddAgendaDrawer} changeAgendaAndGuestsStatus={changeAgendaAndGuestsStatus} deleteAgenda={deleteAgenda} />
                                                    ))}
                                                </div>
                                            </SortableContext>
                                        </DndContext>
                                    ) : null}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <Modal
                title="导出Word版日程"
                centered
                width={1000}
                open={visibleExportPrintAgendaModal}
                onCancel={closeExportPrintAgendaModal}
                footer={
                    showWordTemplateSettings
                        ? [
                              <Button key="save" onClick={saveWordTemplateOnly} disabled={wordExportLoading}>
                                  仅保存设置
                              </Button>,
                              <Button type="primary" key="save-and-export" onClick={exportPrintAgenda} loading={wordExportLoading} disabled={wordExportLoading}>
                                  保存设置并导出
                              </Button>,
                          ]
                        : [
                              <Button type="primary" key="export-agenda" onClick={exportPrintAgenda} loading={wordExportLoading} disabled={wordExportLoading}>
                                  导出日程
                              </Button>,
                          ]
                }
            >
                <Row gutter={24}>
                    <Col span={showWordTemplateSettings ? 14 : 24}>
                        <StyledAgendaExportSetup>
                            <Button size="small" className="agenda-template-setting-btn" onClick={toggleWordTemplateSettings}>
                                {showWordTemplateSettings ? '隐藏模板设置' : '日程模板设置'}
                            </Button>

                            <h3 className="directions">选择要导出日程的会议场次</h3>
                            <div className="conf-hall-tree">
                                <Tree checkable treeData={conferenceHallTreeData} fieldNames={{ title: 'title', key: 'value', children: 'children' }} defaultExpandAll checkedKeys={checkedConfHallKeys} onCheck={onCheckConfHallForAgendaExport} />
                            </div>

                            <div className="confirm-only">
                                <Checkbox checked={confirmOnly} onChange={onChangeConfirmOnly}>
                                    仅导出已接受日程任务的嘉宾
                                </Checkbox>
                            </div>
                            <div className="extra">
                                <span>状态为“日程显示中”且“嘉宾显示中”的日程下的嘉宾，勾选该选项则仅导出日程任务已接受的嘉宾，反之则导出该日程下所有嘉宾。</span>
                                <PopoverTip placement="right" content={<img src="https://mediafiles.cn-healthcare.com/boss/popovertip/medconf_agenda%402x.jpg" alt="" style={{ width: 600 }} />}>
                                    <i className="bi bi-question-circle-fill popover-tip-icon"></i>
                                </PopoverTip>
                            </div>

                            <div className="export-planned-agenda" style={{ marginTop: 10 }}>
                                <Checkbox checked={plannedAgendas} onChange={onChangePlannedAgendas}>
                                    以拟定日程表头导出日程
                                </Checkbox>
                            </div>
                            <div className="extra">
                                <span>勾选后，将以拟定时间、拟定日程、拟定嘉宾表头导出日程</span>
                            </div>

                            <div className="export-include-hidden" style={{ marginTop: 10 }}>
                                <Checkbox checked={includeHidden} onChange={onChangeIncludeHidden}>
                                    隐藏的会议场次、日程、日程嘉宾一并导出
                                </Checkbox>
                            </div>
                            <div className="extra">
                                <span>勾选后，将一并导出隐藏的会议场次、日程、日程嘉宾，并标记“隐藏中”</span>
                            </div>
                        </StyledAgendaExportSetup>
                    </Col>

                    {showWordTemplateSettings && (
                        <Col span={10}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                                <h3 style={{ margin: 0 }}>日程模板设置</h3>
                                <Button size="small" type="text" onClick={toggleWordTemplateSettings}>
                                    &times; 关闭
                                </Button>
                            </div>
                            <p>按以下模板样式设置，生成Word版日程。</p>

                            <Form
                                form={wordTemplateForm}
                                layout="vertical"
                                initialValues={{
                                    print: {
                                        conf_hall_title_background_color: undefined,
                                        conf_hall_title_secondary_background_color: undefined,
                                        new_page_per_conf_hall: false,
                                    },
                                }}
                            >
                                <Form.Item name="print">
                                    <Form.Item label="论坛标题背景色（默认无背景色）" extra="填写形如 #FFFFFF 的色值，该颜色用于打印版日程中会议论坛名称背景颜色">
                                        <div className="color-field-wrap">
                                            <div className="color-field" style={{ display: 'flex', alignItems: 'center' }}>
                                                <Form.Item noStyle shouldUpdate>
                                                    {({ getFieldValue }) => {
                                                        const color = getFieldValue(['print', 'conf_hall_title_background_color']);
                                                        return !!color && <div className="color-previewer" style={{ backgroundColor: `${color}`, borderColor: '#CCCCCC', width: 20, height: 20, border: '1px solid #ccc', borderRadius: 4, display: 'inline-block', marginRight: 8 }}></div>;
                                                    }}
                                                </Form.Item>

                                                <Form.Item noStyle name={['print', 'conf_hall_title_background_color']} rules={[{ pattern: /^#[0-9a-f]{6}$/i, message: '色值不符合格式要求' }]}>
                                                    <Input style={{ width: 120 }} maxLength={7} placeholder="请输入色值" allowClear />
                                                </Form.Item>
                                            </div>
                                            <div style={{ marginTop: 8 }}>
                                                {colorList.map((item, index) => (
                                                    <Tooltip key={index} placement="top" title="点击使用该颜色">
                                                        <div
                                                            onClick={() => changeBgColor(item, ['print', 'conf_hall_title_background_color'])}
                                                            style={{
                                                                backgroundColor: `${item}`,
                                                                borderColor: '#CCCCCC',
                                                                width: 20,
                                                                height: 20,
                                                                border: '1px solid #ccc',
                                                                borderRadius: 4,
                                                                display: 'inline-block',
                                                                marginRight: 8,
                                                                marginBottom: 8,
                                                                cursor: 'pointer',
                                                            }}
                                                        ></div>
                                                    </Tooltip>
                                                ))}
                                            </div>
                                        </div>
                                    </Form.Item>

                                    <Form.Item label="论坛次标题背景色（默认无背景色）" extra="填写形如 #FFFFFF 的色值，该颜色用于打印版日程中会议论坛中次标题背景颜色">
                                        <div className="color-field-wrap">
                                            <div className="color-field" style={{ display: 'flex', alignItems: 'center' }}>
                                                <Form.Item noStyle shouldUpdate>
                                                    {({ getFieldValue }) => {
                                                        const color = getFieldValue(['print', 'conf_hall_title_secondary_background_color']);
                                                        return !!color && <div className="color-previewer" style={{ backgroundColor: `${color}`, borderColor: '#CCCCCC', width: 20, height: 20, border: '1px solid #ccc', borderRadius: 4, display: 'inline-block', marginRight: 8 }}></div>;
                                                    }}
                                                </Form.Item>

                                                <Form.Item noStyle name={['print', 'conf_hall_title_secondary_background_color']} rules={[{ pattern: /^#[0-9a-f]{6}$/i, message: '色值不符合格式要求' }]}>
                                                    <Input style={{ width: 120 }} maxLength={7} placeholder="请输入色值" allowClear />
                                                </Form.Item>
                                            </div>
                                            <div style={{ marginTop: 8 }}>
                                                {colorList.map((item, index) => (
                                                    <Tooltip key={index} placement="top" title="点击使用该颜色">
                                                        <div
                                                            onClick={() => changeBgColor(item, ['print', 'conf_hall_title_secondary_background_color'])}
                                                            style={{
                                                                backgroundColor: `${item}`,
                                                                borderColor: '#CCCCCC',
                                                                width: 20,
                                                                height: 20,
                                                                border: '1px solid #ccc',
                                                                borderRadius: 4,
                                                                display: 'inline-block',
                                                                marginRight: 8,
                                                                marginBottom: 8,
                                                                cursor: 'pointer',
                                                            }}
                                                        ></div>
                                                    </Tooltip>
                                                ))}
                                            </div>
                                        </div>
                                    </Form.Item>

                                    <Form.Item label="每个论坛新起一页" name={['print', 'new_page_per_conf_hall']} valuePropName="checked" extra="开启后每个论坛新页输出，关闭并跨页输出，单论坛日程任务多时建议开启">
                                        <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                                    </Form.Item>
                                </Form.Item>
                            </Form>
                        </Col>
                    )}
                </Row>
            </Modal>

            <Modal
                width={1200}
                title="会议信息一览"
                centered
                mask={{ closable: false }}
                open={visiblePlacesOverviewModal}
                onCancel={closePlaceOverviewModal}
                footer={[
                    <div className="customized-modal-footer" key="customized-modal-footer">
                        <div className="left-col-tools">
                            <Checkbox key="spec-instruction" checked={specInstructionEnabled} onClick={onChangeSpecInstruction}>
                                展示项目特别说明
                            </Checkbox>
                        </div>
                        <div className="right-col-tools">
                            <Space>
                                <Button
                                    key="overview-excel"
                                    onClick={downloadPlacesOverviewExcel}
                                    icon={
                                        <span className="anticon">
                                            <i className="bi bi-file-earmark-excel"></i>
                                        </span>
                                    }
                                    disabled={isEmpty(placesOverviewData?.dates) || isEmpty(placesOverviewData?.places)}
                                >
                                    下载会议信息一览表
                                </Button>
                                <Button
                                    key="overview-image"
                                    onClick={downloadPlacesOverviewImage}
                                    icon={
                                        <span className="anticon">
                                            <i className="bi bi-file-image"></i>
                                        </span>
                                    }
                                    disabled={isEmpty(placesOverviewData?.dates) || isEmpty(placesOverviewData?.places)}
                                >
                                    下载会议信息一览图
                                </Button>
                            </Space>
                        </div>
                    </div>,
                ]}
                className="place-overview-modal"
            >
                {loadingPlacesOverview ? (
                    <Spin />
                ) : (
                    <div className="place-overview-container">
                        {!isEmpty(placesOverviewData?.dates) && !isEmpty(placesOverviewData?.places) ? (
                            <div id="places-overview-table-box">
                                <table style={{ width: 160 + 320 * placesOverviewData.dates.length }}>
                                    <thead>
                                        <tr>
                                            <th className="place">会议地点</th>
                                            {placesOverviewData.dates.map(d => (
                                                <th key={d.date} className="hall">
                                                    {dateTimeFormat(d.date, 'YYYY年M月D日')} <small style={{ fontWeight: 'normal' }}>({!d.hallNum ? '暂无场次' : `${d.hallNum}场`})</small>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {placesOverviewData.places.map((place, index) => (
                                            <tr key={place.id}>
                                                <td className="place">
                                                    {place.name}
                                                    <br />
                                                    <small style={{ fontWeight: 'normal' }}>({!place.hallNum ? '暂无场次' : `${place.hallNum}场`})</small>
                                                </td>
                                                {!isEmpty(place.agendas)
                                                    ? place.agendas.map((p, idx) => {
                                                          const halls = p.halls?.filter(h => h.hidden === '0') || [];
                                                          return (
                                                              <td key={`place_${idx}`} className="place-hall" valign="top">
                                                                  {!isEmpty(halls) ? (
                                                                      halls.map((h, i) => {
                                                                          const dateTimesArr = h.agendasTime?.split(/-(?=\d{4})/) || [];
                                                                          let dateTime = '';
                                                                          if (dateTimesArr.length === 2) {
                                                                              dateTime = convertDateTimeRangeToLocalText(dateTimesArr[0], dateTimesArr[1], 0);
                                                                          }
                                                                          return (
                                                                              <div className="hall-box" key={`place_${idx}_hall_${i}`}>
                                                                                  <div className="hall-time">{dateTime}</div>
                                                                                  <div className="hall-name">
                                                                                      <b>{h.hallInfo}</b> <small>{`YHYC#${h.hallId}`}</small>
                                                                                  </div>
                                                                                  {specInstructionEnabled && !!h.projectSpecificInstructions && <div className="hall-spec-instruction" dangerouslySetInnerHTML={{ __html: `项目特别说明：<br/>${h.projectSpecificInstructions.replace(/\n/g, '<br/>')}` }} />}
                                                                              </div>
                                                                          );
                                                                      })
                                                                  ) : (
                                                                      <span className="empty">暂无数据</span>
                                                                  )}
                                                              </td>
                                                          );
                                                      })
                                                    : dateList.map(d => (
                                                          <td key={d}>
                                                              <span className="empty">暂无数据</span>
                                                          </td>
                                                      ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="empty-overview">暂无数据</div>
                        )}
                    </div>
                )}
            </Modal>

            <Modal title="下载打印版日程" centered className="printAgendaModal" open={visibleDownloadAgenda} onOk={() => setVisibleDownloadAgenda(false)} onCancel={() => setVisibleDownloadAgenda(false)}>
                {showPrintModal ? (
                    <Spin />
                ) : (
                    <div className="downloadAgendaModal">
                        <Alert
                            type="warning"
                            title={
                                <>
                                    <p>最后生成时间：{!!conference?.agendaPrintCreatedAt && dayjs(conference.agendaPrintCreatedAt).format('YYYY年MM月DD日 HH:mm:ss')}</p>
                                    <p>操作人：{conference?.agendaPrintCreatedName}</p>
                                </>
                            }
                        />
                        {(!!conference?.agendaPrintUrl || !!printAgendaUrl) && (
                            <p>
                                <Button type="link" onClick={() => downloadPrintAgenda()}>
                                    下载A4打印版日程
                                </Button>
                            </p>
                        )}
                        <p>
                            日程信息有变更，可以点击
                            <Button type="link" onClick={() => redoGenerate()}>
                                重新生成
                            </Button>
                            ，以下载最新版日程
                        </p>
                    </div>
                )}
            </Modal>

            <Modal
                title="导出Word版主持稿"
                centered
                width={680}
                open={visibleExportPrintHost}
                onCancel={closeExportPrintHost}
                footer={[
                    <Button key="export" type="primary" onClick={exportPrintHost}>
                        导出
                    </Button>,
                ]}
            >
                <StyledAgendaExportSetup>
                    <div className="directions">选择要导出主持稿的会议场次，仅支持单场导出</div>
                    <div className="conf-hall-tree">
                        <Tree
                            treeData={conferenceHallTreeData}
                            fieldNames={{ title: 'title', key: 'value', children: 'children' }}
                            defaultExpandAll
                            value={currentHostConfHallKey}
                            onSelect={onChangeConfHall}
                            titleRender={node => {
                                return (
                                    <>
                                        {node.children && node.children.length > 0 ? (
                                            <span>{node.title}</span>
                                        ) : (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <Radio checked={currentHostConfHallKey && currentHostConfHallKey[0] === node.value} onChange={() => setCurrentHostConfHallKey([node.value])} />
                                                <span>{node.title}</span>
                                            </div>
                                        )}
                                    </>
                                );
                            }}
                        />
                    </div>
                </StyledAgendaExportSetup>
            </Modal>

            <AddConferenceDrawer
                visibleAddConferenceHallDrawer={visibleAddConferenceHallDrawer}
                setVisibleAddConferenceHallDrawer={setVisibleAddConferenceHallDrawer}
                conferenceDetail={conferenceDetail}
                setConferenceDetail={setConferenceDetail}
                currentDate={currentDate.current}
                currentConferenceHall={currentConferenceHall}
                setCurrentConferenceHall={setCurrentConferenceHall}
                dateList={dateList}
                getConferenceList={getConferenceList}
                staffs={staffs}
                enterprisePerson={enterprisePerson}
                conferenceData={conferenceData}
            />

            <AddAgendaDrawer
                visibleAddAgendaDrawer={visibleAddAgendaDrawer}
                setVisibleAddAgendaDrawer={setVisibleAddAgendaDrawer}
                currentDate={currentDate.current}
                currentConferenceHall={currentConferenceHall}
                setConferenceDetail={setConferenceDetail}
                agendaDetail={agendaDetail}
                getAgendasList={getAgendasList}
                setAgendaDetail={setAgendaDetail}
            />

            {Number(currentConferenceHall?.id) > 0 ? <OperationLogDrawer open={hallOperationLogOpen} onClose={() => setHallOperationLogOpen(false)} entityType="conference_hall" entityId={currentConferenceHall.id} module="conference" /> : null}

            <PreviewAgendasDrawer visiblePreviewAgendasDrawer={visiblePreviewAgendasDrawer} setVisiblePreviewAgendasDrawer={setVisiblePreviewAgendasDrawer} conference={conference} staffs={staffs} />

            <ChangeConferenceDateModal open={visibleChangeConferenceDateModal} onCancel={closeChangeConferenceDateModal} conferenceHall={currentChangeConferenceHall} dateList={dateList} conferenceData={conferenceData} onSuccess={onChangeConferenceDateSuccess} />

            <SeatingArrangementModal open={visibleSeatingArrangementModal} onCancel={closeSeatingArrangementModal} currentConferenceHall={currentConferenceHall} getConferenceList={getConferenceList} agendasData={agendasData} />
        </>
    );
}
